import useSWRMutation from 'swr/mutation';
import {isProdEnvironment} from 'utils/environment';
import {UserData} from 'APIs/letrusAPI/user/types';
import flagrAPI from '../axiosInstance';
import {FeatureFlag} from '../types';

function fetchFeatureFlagsRequest() {
  return useSWRMutation<
    FeatureFlag[],
    Error,
    string,
    {flagKeys: string[]; userData?: UserData}
  >(
    '/api/v1/evaluation/batch/',
    async (_, {arg}) => {
      try {
        const response = await flagrAPI('/api/v1/evaluation/batch/', {
          method: 'post',
          data: {
            flagKeys: arg.flagKeys,
            enableDebug: false,
            entities: [
              {
                entityContext: clearObject({
                  isDev: !isProdEnvironment,
                  user_id: arg.userData?.user.id,
                  network_id: arg.userData?.user_roles[0].school_network_id,
                  school_id: arg.userData?.user_roles[0].school,
                  school_group_id: arg.userData?.user_roles[0].school_group,
                  school_grade_id: arg.userData?.user_roles[0].school_grade,
                }),
              },
            ],
          },
        });

        sessionStorage.setItem(
          'featureFlags',
          JSON.stringify(response.data.evaluationResults),
        );

        return response.data.evaluationResults;
      } catch (error: any) {
        throw new Error(error ?? 'Não foi possível obter as flags');
      }
    },
    {
      throwOnError: false,
    },
  );
}

function clearObject(object: Record<string, unknown>) {
  return Object.fromEntries(
    Object.entries(object)
      .filter(([, value]) => value !== null && value !== undefined)
      .map(([key, value]) => [key, String(value)]),
  );
}

export default fetchFeatureFlagsRequest;
